export default "__VITE_ASSET__DkdFiNeb__"